// src/components/tools/RotateTool.js
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { addTool, PlanarRotateTool } from "@cornerstonejs/tools";

addTool(PlanarRotateTool);

export const RotateToolConfig = {
  name: "ROTATE",
  tool: PlanarRotateTool.toolName,
  icon: <RotateRightIcon />,
};